import React, { useContext, useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { ContentfulContext } from '../../../Context/Contentful';
import { CartContext } from '../../../Context/CartContext';

const StyledMultiCaseTabBanner = styled.div`
	h4 {
		font-size: 32px;
		line-height: 40px;
		letter-spacing: 0.25px;
		color: ${(props) => props.titleColor || '#212121'};
	}
`;

const StyledRecruitmentProduct = styled.div``;

function MultiCaseTabBanner({
	props: {
		title,
		image1,
		image2,
		image3,
		image4,
		image5,
		image1Mobile,
		image2Mobile,
		image3Mobile,
		image4Mobile,
		image5Mobile,
		image1Tablet,
		image2Tablet,
		image3Tablet,
		image4Tablet,
		image5Tablet,
		banner1Title,
		banner2Title,
		banner3Title,
		banner4Title,
		banner5Title,
		buttonStyle,
		buttonActiveStyle,
		totalItems,
	},
}) {
	const { products: mainItems, getCaseContents } =
		useContext(ContentfulContext);
	const { addtoCart } = useContext(CartContext);
	const [itemIndex, setItemIndex] = useState(0);
	const [filteredItems, setFilteredItems] = useState([]);

	useEffect(() => {
		if (mainItems.length > 0) {
			let filteredItemss = mainItems.filter(({ product: { name } }) => {
				return (
					name.toLowerCase().indexOf('addon') === -1 &&
					name.toLowerCase().indexOf('add-on') === -1 &&
					name.toLowerCase().indexOf('add on') === -1
				);
			});

			if (filteredItemss.length > 0) {
				if (filteredItemss.length > totalItems) {
					filteredItemss = filteredItemss.slice(0, totalItems);
				}
				setFilteredItems(filteredItemss);
			}
		}
	}, [mainItems]);

	return filteredItems.length > 0 ? (
		<StyledMultiCaseTabBanner>
			<div className='container'>
				{filteredItems.map((item, index) => {
					let {
							product: { itemCode, name },
						} = item,
						image = image1,
						bannerTitle = banner1Title,
						imageTablet = image1Tablet || image1,
						imageMobile = image1Mobile || image1Tablet || image1;

					if (index === 0) {
						image = image1;
						bannerTitle = banner1Title;
						imageTablet = image1Tablet || image1;
						imageMobile = image1Mobile || image1Tablet || image1;
					} else if (index === 1) {
						image = image2;
						bannerTitle = banner2Title;
						imageTablet = image2Tablet || image2;
						imageMobile = image2Mobile || image2Tablet || image2;
					} else if (index === 2) {
						image = image3;
						bannerTitle = banner3Title;
						imageTablet = image3Tablet || image3;
						imageMobile = image3Mobile || image3Tablet || image3;
					} else if (index === 3) {
						image = image4;
						bannerTitle = banner4Title;
						imageTablet = image4Tablet || image4;
						imageMobile = image4Mobile || image4Tablet || image4;
					} else if (index === 4) {
						image = image5;
						bannerTitle = banner5Title;
						imageTablet = image5Tablet || image5;
						imageMobile = image5Mobile || image5Tablet || image5;
					}

					if (itemIndex === index) {
						return (
							<StyledRecruitmentProduct
								className='mb-10 text-center cursor-pointer'
								onClick={() => getCaseContents(itemCode)}
								title='Click to View Case Details'
								key={itemCode}
							>
								<img
									src={image}
									alt={bannerTitle || name}
									title={bannerTitle || name}
									className={`${
										imageMobile || imageTablet
											? 'd-none d-lg-inline-block'
											: 'd-inline-block'
									} mw-100`}
								/>
								{imageTablet && (
									<img
										src={imageTablet}
										alt={bannerTitle || name}
										title={bannerTitle || name}
										className='d-none d-sm-inline-block d-lg-none mw-100'
									/>
								)}
								{imageMobile && (
									<img
										src={imageMobile}
										alt={bannerTitle || name}
										title={bannerTitle || name}
										className='d-inline-block d-sm-none mw-100'
									/>
								)}
							</StyledRecruitmentProduct>
						);
					}
				})}

				<div className='d-flex justify-content-center align-items-center flex-wrap'>
					{filteredItems.map((item, index) => {
						let {
							product: { itemCode, name },
						} = item;

						return (
							<div className='m-10' key={itemCode}>
								<button
									type='button'
									onClick={() => {
										setItemIndex(index);
										// addtoCart(item, true);
									}}
									className={`btn btn-${
										itemIndex === index ? buttonActiveStyle : buttonStyle
									}
									`}
								>
									{index === 0 && banner1Title
										? banner1Title
										: index === 1 && banner2Title
										? banner2Title
										: index === 2 && banner3Title
										? banner3Title
										: index === 3 && banner4Title
										? banner4Title
										: index === 4 && banner5Title
										? banner5Title
										: name}
								</button>
							</div>
						);
					})}
				</div>
			</div>
		</StyledMultiCaseTabBanner>
	) : null;
}

export default MultiCaseTabBanner;
